import { Stack, Typography } from '@mui/material';

export const NotPromotionScenery: React.FC<{
	showDpvalePromotion: boolean;
}> = ({ showDpvalePromotion }) => (
	<Stack mt={'12px'}>
		<Stack direction={'row'}>
			{showDpvalePromotion ? (
				<Typography
					component={'span'}
					sx={{ fontSize: 'var(--font-size-small)', fontWeight: 'normal' }}
				>
					{'No aplican promociones para el pago con dpvale'}
				</Typography>
			) : null}
		</Stack>
	</Stack>
);
